import React from 'react'
import styled from 'styled-components'

const Grid = ({ cols = "1fr", mCols = cols, rows = "auto", mRows = rows, maxWidth = "100%", mar = "0", pc = "center", gap = "10px", bg = "transparent", padding = "0", children }) => {

    // let mobileRows
    // if (mfr == null) {
    //     mobileRows = fr
    // } else {
    //     mobileRows = mfr

    // }
    // let mobileCols
    // if (mfr == null) {
    //     mobileCols = cols
    // } else {
    //     mobileCols = mfr

    // }

    return (
        <Wrap $cols={cols} $mCols={mCols} $rows={rows} $mRows={mRows} $mar={mar} $pc={pc} $maxWidth={maxWidth} $bg={bg} $padding={padding} $gap={gap}>{children}</Wrap>
    )
}

export default Grid


const Wrap = styled.div`
    z-index: 101;
    width: 100%;
   
    /* flex-direction: column; */
    gap: ${(props) => (props.$gap)};
    padding: ${(props) => (props.$padding)};
    display: grid;
    grid-template-columns: ${(props) => (props.$mCols)};
    grid-template-rows: ${(props) => (props.$mRows)};
    background: ${(props) => (props.$bg)};
    place-content: ${(props) => (props.$pc)};
    margin:  ${(props) => (props.$mar)};

    /* place-content: center; */

    
    @media(min-width: 768px) {
        grid-template-columns: ${(props) => (props.$cols)};
        grid-template-rows: ${(props) => (props.$rows)};
        max-width: ${(props) => (props.$maxWidth)};

        }
`
